import React from "react";

const ContactsContext = React.createContext();

export default ContactsContext;